export default __webpack_public_path__ + "static/media/03-persona.ff54388b.svg";